export const normalizeTKey = (key: string) => key as unknown as TemplateStringsArray;